// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Button_button__w\\+JtY {
  padding: 2rem;
  display: flex;
  justify-content: center;
  align-items: center;
  color: var(--white);
  font-size: 1.6rem;
  border-radius: 1rem;
  position: relative;
}
.Button_button__w\\+JtY:hover {
  cursor: pointer;
}
.Button_button__w\\+JtY:active {
  box-shadow: none;
}
.Button_button__w\\+JtY > .Button_triangle__16IKT {
  position: absolute;
  top: 0;
  left: 0;
  width: 25%;
  height: 60%;
  background-color: rgba(255, 255, 255, 0.1);
  border-radius: 1rem 0 0 0;
  clip-path: polygon(0% 0, 100% 0%, 0 100%);
}
.Button_button__w\\+JtY > .Button_triangle__16IKT::before {
  content: "";
  padding-top: 100%;
  width: 100%;
  border: solid transparent;
  box-sizing: border-box;
}

.Button_buttonBlue__oBdQ9 {
  background: var(--gradient-blue);
}
.Button_buttonBlue__oBdQ9:hover {
  box-shadow: var(--shadow-blue-red);
}
.Button_buttonBlue__oBdQ9:active {
  box-shadow: none;
}

.Button_buttonRed__znatj {
  background: var(--gradient-red);
}
.Button_buttonRed__znatj:hover {
  box-shadow: var(--shadow-red-red);
}
.Button_buttonRed__znatj:active {
  box-shadow: none;
}`, "",{"version":3,"sources":["webpack://./src/components/common/Button/Button.module.scss"],"names":[],"mappings":"AAAA;EACC,aAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,mBAAA;EACA,iBAAA;EAEA,mBAAA;EAEA,kBAAA;AADD;AAGC;EACC,eAAA;AADF;AAIC;EACC,gBAAA;AAFF;AAKC;EACC,kBAAA;EACA,MAAA;EACA,OAAA;EACA,UAAA;EACA,WAAA;EACA,0CAAA;EACA,yBAAA;EACA,yCAAA;AAHF;AAKE;EACC,WAAA;EACA,iBAAA;EACA,WAAA;EACA,yBAAA;EACA,sBAAA;AAHH;;AAQA;EACC,gCAAA;AALD;AAOC;EAEC,kCAAA;AANF;AAQC;EACC,gBAAA;AANF;;AASA;EACC,+BAAA;AAND;AASC;EACC,iCAAA;AAPF;AASC;EACC,gBAAA;AAPF","sourcesContent":[".button {\n\tpadding: 2rem;\n\tdisplay: flex;\n\tjustify-content: center;\n\talign-items: center;\n\tcolor: var(--white);\n\tfont-size: 1.6rem;\n\t// background: var(--gradient-blue);\n\tborder-radius: 1rem;\n\t// box-shadow: var(--shadow-blue);\n\tposition: relative;\n\n\t&:hover {\n\t\tcursor: pointer;\n\t\t// box-shadow: var(--shadow-blue-red);\n\t}\n\t&:active {\n\t\tbox-shadow: none;\n\t}\n\n\t& > .triangle {\n\t\tposition: absolute;\n\t\ttop: 0;\n\t\tleft: 0;\n\t\twidth: 25%;\n\t\theight: 60%;\n\t\tbackground-color: rgba(255, 255, 255, 0.1);\n\t\tborder-radius: 1rem 0 0 0;\n\t\tclip-path: polygon(0% 0, 100% 0%, 0 100%);\n\n\t\t&::before {\n\t\t\tcontent: '';\n\t\t\tpadding-top: 100%;\n\t\t\twidth: 100%;\n\t\t\tborder: solid transparent;\n\t\t\tbox-sizing: border-box;\n\t\t}\n\t}\n}\n\n.buttonBlue {\n\tbackground: var(--gradient-blue);\n\n\t&:hover {\n\t\t// box-shadow: var(--shadow-blue);\n\t\tbox-shadow: var(--shadow-blue-red);\n\t}\n\t&:active {\n\t\tbox-shadow: none;\n\t}\n}\n.buttonRed {\n\tbackground: var(--gradient-red);\n\t// box-shadow: var(--shadow-red);\n\n\t&:hover {\n\t\tbox-shadow: var(--shadow-red-red);\n\t}\n\t&:active {\n\t\tbox-shadow: none;\n\t}\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"button": `Button_button__w+JtY`,
	"triangle": `Button_triangle__16IKT`,
	"buttonBlue": `Button_buttonBlue__oBdQ9`,
	"buttonRed": `Button_buttonRed__znatj`
};
export default ___CSS_LOADER_EXPORT___;
